// the rank can be achieved with the following points
export enum TierList {
  Beginner = 0,
  Novice = 501,
  Intermediate = 1001,
  Advanced = 2001,
  Expert = 3501,
  Master = 5001,
}
